<div class="py-14 px-3" [style.font-family]="'var(--vex-font)'">
  <div class="card mx-auto md:w-1/2 text-red-500 text-center p-10">
    <h1 class="italic font-bold text-lg">Payment Failed</h1>
    <p class="italic font-bold text-lg">Your payment couldn't be processed. Please try again.</p>
    <i class="fa-solid fa-circle-exclamation text-[150px] sm:text-[200px] mt-20 animate-bounce"></i>
    <div class="w-[70%] sm:w-1/2 mx-auto">
      <button class="search-btn rounded-lg text-white font-bold" (click)="goTo()">Try again</button>
    </div>
  </div>
</div>
